import React, { useState } from 'react';
import Papa from 'papaparse';
import { Upload, Tooltip, message, Row } from 'antd';
import Button from '../../../shared/globalStyling/Button';
import { zipObject } from 'lodash';
import PropTypes from 'prop-types';
import { UploadOutlined } from '@ant-design/icons';
// Global Styles
import { ButtonText } from '../../../shared/globalStyling/styledText';
import { OrganizationConfig } from '../configs/organizationConfig';

const OrganizationCsvLocationUpload = ({ onComplete, showForm, disabled }) => {
  const [isUploading, setIsUploading] = useState(false);

  const customRequest = ({ file, onSuccess, onError, onComplete, keys }) => {
    setIsUploading(true);
    if (file.name.toLowerCase().includes('csv')) {
      Papa.parse(file, {
        skipEmptyLines: 'greedy',
        error: function (err, file, inputElem, reason) {
          onError({ err, file, inputElem, reason });
        },
        complete: async (results) => {
          const rows = results.data;
          let headers = results.data.shift();
          headers.pop();
          headers.push('RADIUS'); // Ensure RADIUS is included
          // Check if required fields exist, allowing for "RADIUS" or "RADIUS (METERS)"
          const hasRadiusField = headers.some(
            (h) => h === 'RADIUS' || h === 'RADIUS (MILES)' || h.toUpperCase().includes('RADIUS')
          );
          const otherRequiredFields = ['NAME', 'ADDRESS', 'CITY', 'STATE', 'ZIP'];
          const hasOtherFields = otherRequiredFields.every((field) => headers.includes(field));

          if (!hasRadiusField || !hasOtherFields) {
            message.error(
              'Required fields missing. CSV must contain: NAME, ADDRESS, CITY, STATE, ZIP, and RADIUS (in miles). Please check your CSV and try again.'
            );
            setIsUploading(false);
            return;
          }

          const mappedData = rows.map((row) => zipObject(headers, row));
          const response = await onComplete(mappedData);
          if (response) {
            message.error(response);
          } else {
            setIsUploading(false);
          }
          onSuccess('done', file);
        },
      });
    } else {
      message.error('Invalid file type. Only accepts .csv');
      setIsUploading(false);
      return;
    }
  };

  const tooltipText = (
    <React.Fragment>
      <Row>Accept CSV file type.</Row>
      <Row>
        <strong>Important:</strong> RADIUS values must be in miles.
      </Row>
    </React.Fragment>
  );

  return (
    <Upload
      accept={'.csv'}
      showUploadList={false}
      multiple={false}
      customRequest={(params) => customRequest({ ...params, onComplete: onComplete })}
    >
      <Tooltip placement="left" title={tooltipText}>
        <Button
          onClick={showForm}
          disabled={disabled}
          type="primary"
          shape="round"
          icon={<UploadOutlined />}
          loading={isUploading}
        >
          <ButtonText text={'Upload'} />
        </Button>
      </Tooltip>
    </Upload>
  );
};

export default OrganizationCsvLocationUpload;

OrganizationCsvLocationUpload.propTypes = {
  onComplete: PropTypes.func,
};
